import React, { ReactNode } from 'react';
import CookieConsent from '../CookieConsent';
import { CookieConsentData } from '../CookieConsent/types';
import { CookieConsentProvider } from '../CookieConsent/context/CookieConsentContext';

interface CookieConsentWrapperProps {
  data?: CookieConsentData;
  children?: ReactNode;
}

// Global reference to the showSettings function
let globalShowSettings: (() => void) | null = null;

const CookieConsentWrapper: React.FC<CookieConsentWrapperProps> = ({ data, children }) => {
  const showSettings = () => {
    if (globalShowSettings) {
      globalShowSettings();
    }
  };

  if (!data) {
    return <CookieConsentProvider showSettings={showSettings}>{children}</CookieConsentProvider>;
  }

  return (
    <CookieConsentProvider showSettings={showSettings}>
      {children}
      <CookieConsent data={data} onShowSettingsReady={(showSettingsFn: () => void) => {
        globalShowSettings = showSettingsFn;
      }} />
    </CookieConsentProvider>
  );
};

export default CookieConsentWrapper;